module.exports = __webpack_public_path__ + "img/4.091e978e.jpg";